import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import { ContratadosForm } from "../modais"
import Layout from "../Layout"
class ContratadosEditForm extends Component {
  constructor() {
    super()
    this.onSuccess = this.onSuccess.bind(this)
  }
  onSuccess() {
    this.props.history.push("/contratados")
  }
  render() {
    return (
      <Layout tabActive="Contratados">
        <ContratadosForm
          isEditing={true}
          callBackContratados={this.onSuccess}
        />
      </Layout>
    )
  }
}
export default withRouter(ContratadosEditForm)



// WEBPACK FOOTER //
// ./src/views/contratados/ContratadosEditForm.js